import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable, ReplaySubject, tap,shareReplay} from 'rxjs';
import { Navigation } from 'app/core/navigation/navigation.types';
import { environment } from 'environments/environment';

@Injectable({
    providedIn: 'root'
})
export class NavigationService
{
    private _navigation: ReplaySubject<Navigation> = new ReplaySubject<Navigation>(1);
    private baseUrl: string;

    /**
     * Constructor
     */
    constructor(private _httpClient: HttpClient)
    {
        this.baseUrl = `${environment.apiURL}/common`;
    }

    // -----------------------------------------------------------------------------------------------------
    // @ Accessors
    // -----------------------------------------------------------------------------------------------------

    /**
     * Getter for navigation
     */
    get navigation$(): Observable<Navigation>
    {

        return this._navigation.asObservable();
    }

    // -----------------------------------------------------------------------------------------------------
    // @ Public methods
    // -----------------------------------------------------------------------------------------------------

    /**
     * Get all navigation data
     */
    get(): Observable<Navigation>
    {
        return this._httpClient.get<Navigation>(this.baseUrl + '/navigation').pipe(
            tap((navigation) => {
                if ( navigation.compact?.[1]?.children?.length )
                {
                    navigation.compact[1].children.splice(0,1);
                }
                this._navigation.next(navigation);
            }),
            //shareReplay(1)
        );
    }
}
